import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ProductsContext = createContext();

export const useProducts = () => {
  const context = useContext(ProductsContext);
  if (!context) {
    throw new Error('useProducts must be used within a ProductsProvider');
  }
  return context;
};

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/api/products`);
        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }
        const data = await response.json();
        
        // Transform MongoDB string keys to numbers for quantityPricing
        const transformedProducts = data.products.map(product => {
          if (product.quantityPricing) {
            const newQuantityPricing = {};
            for (const [size, prices] of Object.entries(product.quantityPricing)) {
              newQuantityPricing[size] = {};
              for (const [qty, price] of Object.entries(prices)) {
                newQuantityPricing[size][parseInt(qty)] = price;
              }
            }
            product.quantityPricing = newQuantityPricing;
          }
          return product;
        });
        
        setProducts(transformedProducts);
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError(err.message);
        // Fallback to empty array if API fails
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const getProductById = (id) => {
    return products.find(p => p.id === id);
  };

  const value = {
    products,
    loading,
    error,
    getProductById
  };

  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
};

export default ProductsContext;
